import * as React from "react";

import { motion } from "framer-motion";

/**
 * Fades in the children components.
 */
export const FadeIn = ({ children }: React.PropsWithChildren) => {
  return (
    <motion.div
      transition={{ type: "spring", duration: 0.8 }}
      initial={{ opacity: 0, y: -18 }}
      animate={{ opacity: 1, y: 0 }}
    >
      {children}
    </motion.div>
  );
};
